import { createFileRoute } from '@tanstack/react-router';

import { DaysOffPage } from '@/features/days-off/days-off.page';

export const Route = createFileRoute('/__authenticated/time-offs/')({
	component: DaysOffPage,
});
